import type { SavedCryptoAddress } from '@/entities/crypto-address';
import {
  useEditCryptoAddressForm,
  useEditCryptoAddressFormData,
  useEditCryptoAddressFormLogic,
} from '../model';
import {
  ApiErrorText,
  Loader,
  ModalComponentWrapper,
} from '@/shared/components';
import { useTranslation } from 'react-i18next';
import { EditCryptoAddressForm } from './EditCryptoAddressForm';
import { useConfirmationModal } from '@/widgets';

type Props = {
  savedCryptoAddress: SavedCryptoAddress;
  onBack: () => void;
};

export const EditCryptoAddressModal = ({
  savedCryptoAddress,
  onBack,
}: Props) => {
  const { t } = useTranslation();
  const { openModal, Modal: ConfirmationModal } = useConfirmationModal();

  const { isLoading, isError, error, networkOptions } =
    useEditCryptoAddressFormData({
      savedCryptoAddress,
    });

  const { form } = useEditCryptoAddressForm({ savedCryptoAddress });

  const { updateAddress, deleteAddress, isPending } =
    useEditCryptoAddressFormLogic({
      form,
      templateId: savedCryptoAddress.templateId,
      onSuccess: onBack,
      openConfirmationModal: openModal,
    });

  return (
    <ModalComponentWrapper
      title={t('savedAddresses.cryptoAddress.editing.title')}
      onBack={onBack}>
      {isLoading && <Loader />}

      {isError && <ApiErrorText error={error} size="small" />}

      {!isLoading && !isError && (
        <EditCryptoAddressForm
          form={form}
          networkOptions={networkOptions}
          updateAddress={updateAddress}
          deleteAddress={deleteAddress}
          isPending={isPending}
        />
      )}

      {ConfirmationModal}
    </ModalComponentWrapper>
  );
};
